<template>
  <router-link :to="linkTo" class="card block  my-3 mx-3">
    <img class="w-full h-img object-cover" :src="imageUrl" :alt="imageAlt" />
    <div class="mx-2">

      
      <div class="h-60  p-2 ">
        <h3 class="title">{{ title }} </h3>
      </div>

 
      <div class="h-90 p-2 ">

      <p class="description"> {{  description.length <= 10
          ? `${description}`
          : `${description.split(" ").slice(0, 13).join(" ") + " ..."}` }} </p>

          </div>
      <div >
        <router-link class="card-btn  rounded" :to="linkToDetail">
          {{ buttonText }}
        </router-link>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    linkTo: {
      type: [String, Object],
      required: true,
    },
    linkToDetail:{
      type: [String, Object],
      required: true,
    }
  },

};
</script>

<style scoped>
.card {
  width: 345px;
  height: 450px;
  background-color: #f5f2f2;
  overflow: hidden;
  border-radius: 20px;
}
.card:hover {
  background-color: #fafafa;
  box-shadow: 0px 8px 12px 0px rgba(10, 10, 10, 0.4);
}
.h-img {
  height: 250px;
}
.h-60{
  height: 60px;
}
.h-90 {
  height: 90px;
}
.card-btn {
  background-color: #cfcfcf;

  color: #216e2f;
  padding: 8px 8px;
}
.card-btn:hover {
  background-color: #ebebeb;

  color: #08af27;
}
.title {
  color: #1a2f5f;
  font-weight: 700;
}
.description {
  color: #234aa5;
  font-weight: 400;
}

</style>
